/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bulkPriceUpdate } from '../fn/pricing/bulk-price-update';
import { BulkPriceUpdate$Params } from '../fn/pricing/bulk-price-update';
import { BulkPriceUpdateResponse } from '../models/bulk-price-update-response';
import { getOriginalPricing } from '../fn/pricing/get-original-pricing';
import { GetOriginalPricing$Params } from '../fn/pricing/get-original-pricing';
import { getProductSortimentPricingList } from '../fn/pricing/get-product-sortiment-pricing-list';
import { GetProductSortimentPricingList$Params } from '../fn/pricing/get-product-sortiment-pricing-list';
import { getProductSortimentsForPricing } from '../fn/pricing/get-product-sortiments-for-pricing';
import { GetProductSortimentsForPricing$Params } from '../fn/pricing/get-product-sortiments-for-pricing';
import { OriginalPricingResponse } from '../models/original-pricing-response';
import { PageProductSortimentPricingPageResponse } from '../models/page-product-sortiment-pricing-page-response';
import { ProductSortimentsPricingResponse } from '../models/product-sortiments-pricing-response';
import { updateProductSortimentEntryPrices } from '../fn/pricing/update-product-sortiment-entry-prices';
import { UpdateProductSortimentEntryPrices$Params } from '../fn/pricing/update-product-sortiment-entry-prices';


/**
 * Product sortiment pricing endpoints. Prices are stored per product sortiment entry (site assignment) and are segmented by customer type: manufacturerOrImporter, wholesaler, retailer, endConsumer. Each segment has a normal 'price' and an optional 'specialPrice' (promotional/discounted price). The available segments for a site depend on the approved merchant types of that site.
 */
@Injectable({ providedIn: 'root' })
export class PricingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateProductSortimentEntryPrices()` */
  static readonly UpdateProductSortimentEntryPricesPath = '/pricing/selected';

  /**
   * Updates prices for product sortiment entries.
   *
   * Sets normal and special prices per pricing segment for the specified productSortimentEntryIds. Segments: manufacturerOrImporter, wholesaler, retailer, endConsumer. An unset (null) price field is ignored; to remove a price use the bulk-update endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductSortimentEntryPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductSortimentEntryPrices$Response(params: UpdateProductSortimentEntryPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateProductSortimentEntryPrices(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates prices for product sortiment entries.
   *
   * Sets normal and special prices per pricing segment for the specified productSortimentEntryIds. Segments: manufacturerOrImporter, wholesaler, retailer, endConsumer. An unset (null) price field is ignored; to remove a price use the bulk-update endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProductSortimentEntryPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductSortimentEntryPrices(params: UpdateProductSortimentEntryPrices$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateProductSortimentEntryPrices$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getProductSortimentsForPricing()` */
  static readonly GetProductSortimentsForPricingPath = '/pricing/selected';

  /**
   * Gets pricing details for selected product sortiments.
   *
   * Returns full pricing data for the specified productSortimentIds. The response groups per-product sortiment entries by site, exposing normal and special prices for each pricing segment (manufacturerOrImporter, wholesaler, retailer, endConsumer).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSortimentsForPricing()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductSortimentsForPricing$Response(params: GetProductSortimentsForPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductSortimentsPricingResponse>>> {
    const obs = getProductSortimentsForPricing(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets pricing details for selected product sortiments.
   *
   * Returns full pricing data for the specified productSortimentIds. The response groups per-product sortiment entries by site, exposing normal and special prices for each pricing segment (manufacturerOrImporter, wholesaler, retailer, endConsumer).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductSortimentsForPricing$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductSortimentsForPricing(params: GetProductSortimentsForPricing$Params, context?: HttpContext): Observable<Array<ProductSortimentsPricingResponse>> {
    const resp = this.getProductSortimentsForPricing$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProductSortimentsPricingResponse>>): Array<ProductSortimentsPricingResponse> => r.body)
    );
  }

  /** Path part for operation `bulkPriceUpdate()` */
  static readonly BulkPriceUpdatePath = '/pricing/bulk-update';

  /**
   * Bulk price update (synchronization).
   *
   * Updates prices for multiple products in a single call. Each item in the request identifies a product by siteId and productId (= packagingUnitId) and supplies a map of PricingSegment → PriceDetails. Each PriceDetails has a mandatory 'price' (normal price) and an optional 'specialPrice' (promotional price). The response includes per-item status (UPDATED, ADDED, REMOVED, FAILED) and error codes for failures. Intended for TECHNICAL_USER service accounts (e.g. PRS synchronization). Use GET /site/{siteId}/products to verify results after bulk update.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkPriceUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkPriceUpdate$Response(params: BulkPriceUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkPriceUpdateResponse>> {
    const obs = bulkPriceUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Bulk price update (synchronization).
   *
   * Updates prices for multiple products in a single call. Each item in the request identifies a product by siteId and productId (= packagingUnitId) and supplies a map of PricingSegment → PriceDetails. Each PriceDetails has a mandatory 'price' (normal price) and an optional 'specialPrice' (promotional price). The response includes per-item status (UPDATED, ADDED, REMOVED, FAILED) and error codes for failures. Intended for TECHNICAL_USER service accounts (e.g. PRS synchronization). Use GET /site/{siteId}/products to verify results after bulk update.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkPriceUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkPriceUpdate(params: BulkPriceUpdate$Params, context?: HttpContext): Observable<BulkPriceUpdateResponse> {
    const resp = this.bulkPriceUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BulkPriceUpdateResponse>): BulkPriceUpdateResponse => r.body)
    );
  }

  /** Path part for operation `getProductSortimentPricingList()` */
  static readonly GetProductSortimentPricingListPath = '/pricing';

  /**
   * Gets product sortiment pricing list.
   *
   * Returns the paginated pricing list for the authenticated merchant's product sortiment. Only product sortiment entries that are assigned to at least one site are included. Each entry carries the productSortimentId and product metadata for use in subsequent pricing read/write calls.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSortimentPricingList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductSortimentPricingList$Response(params: GetProductSortimentPricingList$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSortimentPricingPageResponse>> {
    const obs = getProductSortimentPricingList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets product sortiment pricing list.
   *
   * Returns the paginated pricing list for the authenticated merchant's product sortiment. Only product sortiment entries that are assigned to at least one site are included. Each entry carries the productSortimentId and product metadata for use in subsequent pricing read/write calls.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductSortimentPricingList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getProductSortimentPricingList(params: GetProductSortimentPricingList$Params, context?: HttpContext): Observable<PageProductSortimentPricingPageResponse> {
    const resp = this.getProductSortimentPricingList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductSortimentPricingPageResponse>): PageProductSortimentPricingPageResponse => r.body)
    );
  }

  /** Path part for operation `getOriginalPricing()` */
  static readonly GetOriginalPricingPath = '/pricing/original';

  /**
   * Gets base prices for a product sortiment.
   *
   * Returns base (pre-discount) prices for the specified productSortimentId, grouped by site. Only ENABLED sortiment entries are included. When 'isRequestedAsDiscountReceiver=true', only ACTIVE prices relevant to the caller's approved merchant types are returned — use this when calculating discounts for a receiving merchant. When false, the full pricing view for the discount-giving side is returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOriginalPricing()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOriginalPricing$Response(params: GetOriginalPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<OriginalPricingResponse>> {
    const obs = getOriginalPricing(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets base prices for a product sortiment.
   *
   * Returns base (pre-discount) prices for the specified productSortimentId, grouped by site. Only ENABLED sortiment entries are included. When 'isRequestedAsDiscountReceiver=true', only ACTIVE prices relevant to the caller's approved merchant types are returned — use this when calculating discounts for a receiving merchant. When false, the full pricing view for the discount-giving side is returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOriginalPricing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOriginalPricing(params: GetOriginalPricing$Params, context?: HttpContext): Observable<OriginalPricingResponse> {
    const resp = this.getOriginalPricing$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OriginalPricingResponse>): OriginalPricingResponse => r.body)
    );
  }

}
